// Weight/volume products carry fractional quantities (kg, litre); "piece"
// products are always whole numbers. Matches the backend's
// FRACTIONAL_UNIT_TYPES in app/services/inventory_service.py.
const FRACTIONAL_UNITS = new Set(["kg", "litre"]);

// Display formatting: whole numbers for "piece" products (how a shopkeeper
// counts pieces), 3 decimals + unit suffix for weight/volume products -
// matches the ledger's NUMERIC(12,3) precision (0.001 kg = 1 gram).
export function formatQuantity(value, unitOfMeasure) {
  const n = Number(value || 0);
  if (FRACTIONAL_UNITS.has(unitOfMeasure)) {
    return `${n.toFixed(3)} ${unitOfMeasure}`;
  }
  if (unitOfMeasure === "piece") {
    return `${Math.round(n)}`;
  }
  // No unit_of_measure available (e.g. a historical sale line item, which
  // deliberately doesn't snapshot it - or a report row that doesn't carry
  // it): show 3 decimals only if the value actually has a fractional part,
  // so a plain whole number like "3" doesn't become "3.000".
  return Number.isInteger(n) ? `${n}` : n.toFixed(3);
}

// <input type="number" step="..."> for a quantity field, derived from a
// product's unit_of_measure. step="1" makes the browser reject/step
// non-integer input for piece products (native HTML5 form validation blocks
// submit on a step mismatch); step="0.001" matches the ledger's precision
// for weight/volume. This is a UX nicety only - the API is the actual
// source of truth for rejecting fractional pieces.
export function quantityStep(unitOfMeasure) {
  return FRACTIONAL_UNITS.has(unitOfMeasure) ? "0.001" : "1";
}
